export default __webpack_public_path__ + "static/Collectius_logo-ba6d32789aec8e8085598d445aedf46e.png";